import { createSlice } from "@reduxjs/toolkit";
import { ISecretKeysSlice } from "../../models/admin/secretKeys/secretKeys";
import { getSecretKeys, getDecryptedSecretKey } from "./secretKeysActions";

const initialState: ISecretKeysSlice = {
  secretKeys: [],
  decryptedKey: {
    id: "",
    key: "",
    value: "",
  },
};

const secretKeysSlice = createSlice({
  name: "secretKeys",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSecretKeys.fulfilled, (state, { payload }) => {
      state.secretKeys = payload.data || [];
    });
    builder.addCase(getDecryptedSecretKey.fulfilled, (state, { payload }) => {
      state.decryptedKey = payload.data || {
        id: "",
        key: "",
        value: "",
      };
    });
  },
});

export default secretKeysSlice.reducer;
